<template>
    <div class="order">
        <div class="search m-b-20">
            <div class="search-box flex-row">
                <img class="searchImg" :src="search" alt="" >
                <input class="searchVal" placeholder="请输入关键字搜索" v-model="value" type="text">
            </div>
        </div>
        <ul class="orderList" >
            <li class="item m-b-20" v-for="(item, index) in orderList" :key="index" >
                <div class="title brder-b flex-row">
                    <p class="orderNumber">订单号：{{item.orderNumber}}</p>
                    <div class="orderStats">
                        <span v-if="item.orderStatus ==1239 " @click="viewContract(item)">报修</span>
                        <span v-if="item.orderStatus ==1239"  @click="viewInvoiceNumber()">发票申请</span>
                        <span>{{item.orderStatusName}}</span>
                        <span v-if="item.orderStatusName ==0 ">待送货</span>
                    </div>
                </div>
                <div class="product flex-row m-t-25" @click="viewPage(item.orderId)">
                    <p>产品类别：{{item.categoryName}}</p>
                    <span class="time">创建时间：{{item.createTime}}</span>
                </div>
                <div class="product m-t-25">所属门店：{{item.storeName}} </div>
                <div class="product m-t-25 flex-row m-b-20">
                    <p>合同金额：<span class="numbers">¥{{item.contractMoney}}</span></p>
                    <span class="invoice">未开票</span>
                </div>
                <div class="info brder-t flex-row">
                    <div class="flex-row information">
                        <img :src="product" alt="">
                        <div>
                            <p class="names">{{item.salesmanName}}</p>
                            <p :tel="item.salesmanPhone">{{item.salesmanPhone}}</p>
                        </div>
                    </div>
                    <img :src="tel" alt="" @click="viewPhone(item.salesmanPhone)" >
                </div>
            </li>
            <!-- <li class="item m-b-20">
                <div class="title brder-b flex-row">
                    <p class="orderNumber">订单号：2384728927498</p>
                    <div class="orderStats">
                        <span>待付款</span>
                    </div>
                </div>
                <div class="product flex-row m-t-25">
                    <p>产品类别：橱柜</p>
                    <span class="time">创建时间：2018-06-27</span>
                </div>
                <div class="product m-t-25">所属门店：北京大钟寺店 </div>
                <div class="product m-t-25 flex-row m-b-20">
                    <p>合同金额：<span class="numbers">¥30000.00</span></p>
                    <span class="invoice">未开票</span>
                </div>
                <div class="info brder-t flex-row">
                    <div class="flex-row information">
                        <img :src="product" alt="">
                        <div>
                            <p class="names">张三</p>
                            <p>189-9967-1670</p>
                        </div>
                    </div>
                    <img :src="tel" alt="">
                </div>
            </li>
            <li class="item m-b-20">
                <div class="title brder-b flex-row">
                    <p class="orderNumber">订单号：2384728927498</p>
                    <div class="orderStats">
                        <span class="delivery">待收货</span>
                    </div>
                </div>
                <div class="product flex-row m-t-25">
                    <p>产品类别：橱柜</p>
                    <span class="time">创建时间：2018-06-27</span>
                </div>
                <div class="product m-t-25">所属门店：北京大钟寺店 </div>
                <div class="product m-t-25 flex-row m-b-20">
                    <p>合同金额：<span class="numbers">¥30000.00</span></p>
                    <span class="invoice">未开票</span>
                </div>
                <div class="info brder-t flex-row">
                    <div class="flex-row information">
                        <img :src="product" alt="">
                        <div>
                            <p class="names">张三</p>
                            <p>189-9967-1670</p>
                        </div>
                    </div>
                    <img :src="tel" alt="">
                </div>
            </li>
            <li class="item m-b-20">
                <div class="title brder-b flex-row">
                    <p class="orderNumber">订单号：2384728927498</p>
                    <div class="orderStats">
                        <span>已取消</span>
                    </div>
                </div>
                <div class="product flex-row m-t-25">
                    <p>产品类别：橱柜</p>
                    <span class="time">创建时间：2018-06-27</span>
                </div>
                <div class="product m-t-25">所属门店：北京大钟寺店 </div>
                <div class="product m-t-25 flex-row m-b-20">
                    <p>合同金额：<span class="numbers">¥30000.00</span></p>
                    <span class="invoice">未开票</span>
                </div>
                <div class="info brder-t flex-row">
                    <div class="flex-row information">
                        <img :src="product" alt="">
                        <div>
                            <p class="names">张三</p>
                            <p>189-9967-1670</p>
                        </div>
                    </div>
                    <img :src="tel" alt="">
                </div>
            </li>
            <li class="item m-b-20">
                <div class="title brder-b flex-row">
                    <p class="orderNumber">订单号：2384728927498</p>
                    <div class="orderStats">
                        <span>待维修</span>
                    </div>
                </div>
                <div class="product flex-row m-t-25">
                    <p>产品类别：橱柜</p>
                    <span class="time">创建时间：2018-06-27</span>
                </div>
                <div class="product m-t-25">所属门店：北京大钟寺店 </div>
                <div class="product m-t-25 flex-row m-b-20">
                    <p>合同金额：<span class="numbers">¥30000.00</span></p>
                    <span class="invoice">未开票</span>
                </div>
                <div class="info brder-t flex-row">
                    <div class="flex-row information">
                        <img :src="product" alt="">
                        <div>
                            <p class="names">张三</p>
                            <p>189-9967-1670</p>
                        </div>
                    </div>
                    <img :src="tel" alt="">
                </div>
            </li>
            <li class="item m-b-20">
                <div class="title brder-b flex-row">
                    <p class="orderNumber">订单号：2384728927498</p>
                    <div class="orderStats">
                        <span>维修完成</span>
                    </div>
                </div>
                <div class="product flex-row m-t-25">
                    <p>产品类别：橱柜</p>
                    <span class="time">创建时间：2018-06-27</span>
                </div>
                <div class="product m-t-25">所属门店：北京大钟寺店 </div>
                <div class="product m-t-25 flex-row m-b-20">
                    <p>合同金额：<span class="numbers">¥30000.00</span></p>
                    <span class="invoice">未开票</span>
                </div>
                <div class="info brder-t flex-row">
                    <div class="flex-row information">
                        <img :src="product" alt="">
                        <div>
                            <p class="names">张三</p>
                            <p>189-9967-1670</p>
                        </div>
                    </div>
                    <img :src="tel" alt="">
                </div>
            </li> -->
        </ul>
    </div>
</template>
<script>
import search from '@/assets/img/search.png';
import product from '@/assets/img/product.jpg';
import tel from '@/assets/img/tel.png';
import { listOrder } from '@/api/index';
export default {
    data(){
        return {
            search,
            product,
            tel,
            value:'',
            orderList:[]
        }
    },
    created(){
        //this.getData();
    },
    methods:{
        viewPage(id){
            this.$router.push({path:'/orderDetails', query:{id: id}});
        },
        /**
         * 获取订单列表
         * @method getData
         */
        getData(){
            let data = this.$loca.getItem('phone');
            let name = this.$loca.getItem('name');
            listOrder({phone: data, name: name, orderType: 0,orderNumber: this.value}).then(res => {
                this.orderList = res.data;
            }).catch(error => {
                console.log('获取全部订单 src/views/order/order.vue');
            })
        },
        viewPhone(item){
             window.location.href = 'tel://' + item;
        },
        viewContract(item){
            this.$router.push({path: '/adContract', query:{ item: item}});
        },
        viewInvoiceNumber(item){
            this.$router.push({path: '/InvoiceNumber', query:{ item: item}});
        }
    }
}
</script>
<style lang="scss" scoped>
.order{
    background: $color-ed;
    .search{
        height: 82px;
        background: $ffff;
        .search-box{
            width:670px;
            height:60px;
            background:rgba(255,255,255,1);
            border:2px solid rgba(229,229,229,1);
            border-radius:10px;
            margin:18px 0 0 39px;
            align-items: center;
            .searchImg{
                margin-left: 17px;
                width: 24px;
                height: 24px;
            }
            .searchVal{
                margin-left: 18px;
                width: 600px;
                height: 100%;
            }
        }
    }
    .orderList{
        background: $color-ed;
        .item{
            // height: 334px;
            background: $ffff;
            padding: 0 20px;
            .title{
                padding: 18px 0 15px 0; 
                justify-content: space-between;
                .orderNumber{
                    font-size:28px;
                    color:rgba(51,51,51,1);
                    margin-left: 18px;
                }
                .orderStats{
                    font-size:20px;
                    color:rgba(86,180,240,1);
                    margin-right: 11px;
                    span{
                        margin-left: 15px;
                    }
                }
            }
            .product{
                margin-left: 14px;
                font-size:24px;
                color: $color-102;
                justify-content: space-between;
                align-items: center;
                .time{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-187;
                }
                .numbers{
                    font-size:24px;
                    color:$color-81;
                }
                .invoice{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-153;
                }
            }
            .info{
                padding: 16px 0 10px 0;
                font-size:24px;
                color:$color-153;
                width: auto;
                align-items: center;
                justify-content: space-between;
                img{
                    width: 54px;
                    height: 54px;
                }
                .information{
                    align-items:center;
                    .names{
                        margin-bottom: 7px;
                    }
                    img{
                        width: 65px;
                        height: 65px;
                        margin: 0 25px 0 21px;
                    }
                }
            }
        }
    }
}
.delivery{
    color:$color-162;
}
</style>

